var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-label',{attrs:{"color":_vm.color,"title":_vm.title}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }